import { Box, Container, Typography } from "@mui/material";
import React from "react";

import FormBuilder3 from "../components/FormBuilder3";
import Header from "../components/Header";
import nbev from "../assets/nbev-consumer.json";
import Particle from "../components/Particles";


function NbevSurvey() {
  return (
    <Box
      sx={{
        background: "#263859",
      }}
    >
      {/* <Particle /> */}

      <Header />
      <Container maxWidth="md" sx={{ marginTop: "2rem" }}>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", marginBottom: "2rem", color: "#fff" }}
        >
          Nbev survey
        </Typography>
        {/* <FormBuilder2 /> */}
        <FormBuilder3 questions={nbev} />
        {/* <FormBuilder4 questions={nbev} /> */}
      </Container>
    </Box>
  );
}

export default NbevSurvey;
